import { render } from "./Wiretransfer.vue?vue&type=template&id=1142cf6b"
import script from "./Wiretransfer.vue?vue&type=script&lang=js"
export * from "./Wiretransfer.vue?vue&type=script&lang=js"

import "./Wiretransfer.vue?vue&type=style&index=0&id=1142cf6b&lang=scss"

import exportComponent from "/home/user/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__